"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaybuyApplicationStart = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var get_providers_1 = require("../../../../api/calls/loan/get_providers");
var get_branches_1 = require("../../../../api/calls/loan/get_branches");
var application_1 = require("../../../../api/calls/lay-buy/application");
var get_basket_1 = require("../../../../api/calls/basket/get_basket");
var get_laybuy_1 = require("../../../../api/calls/lay-buy/get_laybuy");
var main_1 = require("../../../../reducers/slices/main");
var page_path_1 = require("../../components/page_path");
var disclaimer_1 = require("./components/disclaimer");
var functions_1 = require("../../../../constants/functions");
var steps_1 = require("./constants/steps");
var route_names_1 = require("../../../../constants/route_names");
var symbols_1 = require("../../../../constants/symbols");
var lay_buys_1 = require("../lay_buys");
var LaybuyApplicationStart = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var params = (0, react_router_dom_1.useParams)();
    var laybuy_id = params.laybuy_id;
    var _a = (0, react_1.useState)(false), isSaving = _a[0], setIsSaving = _a[1];
    var _b = (0, react_1.useState)(""), laybuyAmount = _b[0], setLaybuyAmount = _b[1];
    var _c = (0, react_1.useState)(""), laybuyTerm = _c[0], setLaybuyTerm = _c[1];
    var _d = (0, react_1.useState)(""), laybuyFrequency = _d[0], setLaybuyFrequency = _d[1];
    var _e = (0, react_1.useState)(""), laybuyProvider = _e[0], setlaybuyProvider = _e[1];
    var _f = (0, react_1.useState)(""), laybuyBranch = _f[0], setlaybuyBranch = _f[1];
    var _g = (0, react_1.useState)([]), branches = _g[0], setBranches = _g[1];
    var _h = (0, react_1.useState)([]), providers = _h[0], setProviders = _h[1];
    var _j = (0, react_1.useState)(""), laybuyTermError = _j[0], setLaybuyTermError = _j[1];
    var _k = (0, react_1.useState)(""), laybuyFrequencyError = _k[0], setLaybuyFrequencyError = _k[1];
    var _l = (0, react_1.useState)(""), acceptedLaybuyError = _l[0], setAcceptedLaybuyError = _l[1];
    var _m = (0, react_1.useState)([]), laybuyTerms = _m[0], setLaybuyTerms = _m[1];
    var _o = (0, react_1.useState)([]), laybuyFrequencies = _o[0], setLaybuyFrequencies = _o[1];
    var _p = (0, react_1.useState)(false), acceptedLaybuy = _p[0], setAcceptedLaybuy = _p[1];
    // const [isModalOpen, setModalIsOpen] = useState<boolean>(false);
    var _q = (0, react_1.useState)(null), activeLaybuy = _q[0], setActiveLaybuy = _q[1];
    var _r = (0, react_1.useState)(false), airtimeOnly = _r[0], setAirtimeOnly = _r[1];
    var _s = (0, react_1.useState)({}), activeUser = _s[0], setActiveUser = _s[1];
    var _t = (0, react_1.useState)(""), providerName = _t[0], setProviderName = _t[1];
    //Set uneditable defaults for product lay-buy
    (0, react_1.useEffect)(function () {
        updateDetails();
    }, [activeLaybuy, branches, providers, laybuyBranch]);
    var updateDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, providers_1, provider, _a, branches_1, branch, suitableProvider;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(activeLaybuy && (activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.is_product))) return [3 /*break*/, 2];
                    // Check if provider and branch are already set from checkout
                    if ((_b = activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.provider) === null || _b === void 0 ? void 0 : _b.id) {
                        // Provider and branch already set from checkout, don't override
                        return [2 /*return*/];
                    }
                    if (!airtimeOnly) {
                        if (providers.length > 0) {
                            // Default to Bravo provider for lay-buy flow
                            for (_i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
                                provider = providers_1[_i];
                                if (provider.label.toLowerCase() == "bravo") {
                                    setlaybuyProvider(provider.value);
                                    break;
                                }
                            }
                        }
                        if (branches.length > 0) {
                            // Default to Bravo Main Warehouse for lay-buy flow
                            for (_a = 0, branches_1 = branches; _a < branches_1.length; _a++) {
                                branch = branches_1[_a];
                                if (branch.label.toLowerCase() == "bravo main warehouse") {
                                    setlaybuyBranch(branch.value);
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        // For airtime-only products, still use regular providers and branches
                        // but exclude Sky Virtual Store
                        if (providers.length > 0) {
                            suitableProvider = providers.find(function (p) { return p.label.toLowerCase() !== "sky virtual store"; });
                            if (suitableProvider) {
                                setlaybuyProvider(suitableProvider.value);
                            }
                        }
                        // Branch will be set after provider is selected and branches are loaded
                    }
                    if (!((activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.basket_id) && laybuyBranch)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, get_basket_1.get_basket)({ _id: activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.basket_id }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                            var _res;
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!response.success) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, functions_1.isAirtimeOnly)((_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.product_list)];
                                    case 1:
                                        _res = _b.sent();
                                        if (!_res) {
                                            dispatch((0, main_1.setContentModal)({
                                                title: "Disclaimer",
                                                content: (react_1.default.createElement(disclaimer_1.Disclaimer, { onProceed: function () {
                                                        saveLaybuyDetails();
                                                    } })),
                                            }));
                                        }
                                        setAirtimeOnly(_res);
                                        return [3 /*break*/, 3];
                                    case 2:
                                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                                        _b.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (laybuyProvider) {
            //Get Branches
            (0, get_branches_1.getProviderBranches)({ provider_id: laybuyProvider }).then(function (response) {
                var _a;
                if (response.success) {
                    var tempData_1 = [];
                    (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.forEach(function (doc) {
                        var _a;
                        var branchData = doc.data();
                        // Filter out offline branches and Sky Virtual Store for lay-buys
                        if (!branchData.offline && branchData.name.toLowerCase() !== "sky virtual store" && ((_a = branchData.branch_number) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== "skyvirst") {
                            tempData_1.push({ label: branchData.name, value: doc.id });
                        }
                    });
                    setBranches(tempData_1);
                }
                else {
                }
            });
        }
    }, [laybuyProvider]);
    //Get Provider
    (0, react_1.useEffect)(function () {
        (0, get_providers_1.getProviders)().then(function (response) {
            var _a;
            if (response.success) {
                var tempData_2 = [];
                (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.forEach(function (doc) {
                    var _a;
                    var providerData = doc.data();
                    // For lay-buy flow: 
                    // - Include Bravo (special exception even though allow_loans is false)
                    // - Include providers with allow_loans but NOT product_loans (filters out Zero2Hero)
                    var isBravo = ((_a = providerData.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "bravo";
                    var allowsLaybuyLoans = providerData.allow_loans && !providerData.product_loans;
                    if (providerData.active && (isBravo || allowsLaybuyLoans)) {
                        tempData_2.push({ label: providerData.name, value: doc.id });
                    }
                });
                setProviders(tempData_2);
            }
        });
    }, []);
    var checkAirStatus = function () {
        if (activeLaybuy) {
            // Providers are already filtered at fetch level to exclude Zero2Hero (product_loans)
            // and include Bravo as special exception
            setLaybuyTerms([
                { label: "3 Months", value: "3" },
                { label: "6 Months", value: "6" },
            ]);
            setLaybuyFrequencies([
                { label: "Monthly", value: "1" },
                { label: "Bi-Weekly", value: "2" },
                { label: "Weekly", value: "4" },
            ]);
        }
    };
    (0, react_1.useEffect)(function () {
        checkAirStatus();
    }, [activeLaybuy, airtimeOnly]);
    (0, react_1.useEffect)(function () {
        if (laybuy_id) {
            //Get Lay-buy
            (0, get_laybuy_1.getLaybuy)({ laybuy_id: laybuy_id }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var laybuyData_1;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!response.success) return [3 /*break*/, 4];
                            return [4 /*yield*/, response.content.data()];
                        case 1:
                            laybuyData_1 = _d.sent();
                            setActiveLaybuy(laybuyData_1);
                            setLaybuyAmount(laybuyData_1 === null || laybuyData_1 === void 0 ? void 0 : laybuyData_1.amount);
                            // setLaybuyTerm(laybuyData?.terms);
                            // Set provider and branch if they exist from checkout
                            if ((_a = laybuyData_1 === null || laybuyData_1 === void 0 ? void 0 : laybuyData_1.provider) === null || _a === void 0 ? void 0 : _a.id) {
                                setlaybuyProvider(laybuyData_1.provider.id);
                            }
                            if ((_b = laybuyData_1 === null || laybuyData_1 === void 0 ? void 0 : laybuyData_1.branch) === null || _b === void 0 ? void 0 : _b.id) {
                                setlaybuyBranch(laybuyData_1.branch.id);
                            }
                            if (!((_c = laybuyData_1 === null || laybuyData_1 === void 0 ? void 0 : laybuyData_1.provider) === null || _c === void 0 ? void 0 : _c.id)) return [3 /*break*/, 3];
                            return [4 /*yield*/, (0, get_providers_1.getProviders)().then(function (response) {
                                    var _a, _b;
                                    if (response.success) {
                                        var provider = response.content.docs.find(function (doc) { return doc.id === laybuyData_1.provider.id; });
                                        if (provider) {
                                            setProviderName((_b = (_a = provider.data()) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Not Set");
                                        }
                                    }
                                })];
                        case 2:
                            _d.sent();
                            _d.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                            _d.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
        }
    }, [laybuy_id]);
    //Create Lay-buy
    var saveLaybuyDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validateDetails()) return [3 /*break*/, 4];
                    setIsSaving(true);
                    if (!activeLaybuy) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, application_1.update_laybuy_application)({
                            uid: laybuy_id,
                            term: "".concat(laybuyTerm, " months"),
                            payment_frequency: Number(laybuyFrequency),
                            remainingInstallments: parseInt(calculateNumberOfInstallments()),
                            agree_terms: true,
                            provider: laybuyProvider,
                            is_product: true,
                        }).then(function (response) {
                            if (response.success) {
                                setIsSaving(false);
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                                navigate("".concat(route_names_1.ROUTE_LAYBUY_APPLICATION, "/").concat(steps_1.APP_STEP_KYC, "/").concat(laybuy_id));
                            }
                            else {
                                dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                            }
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, application_1.create_laybuy_application)({
                        provider: laybuyProvider,
                        branch: laybuyBranch,
                        amount: laybuyAmount,
                        term: "".concat(laybuyTerm, " months"),
                        payment_frequency: Number(laybuyFrequency),
                        status: lay_buys_1.LaybuyStatus.AWAITING_CHECKOUT,
                        agree_terms: true,
                        date_started: new Date(),
                    }).then(function (response) {
                        var _a;
                        if (response.success) {
                            setIsSaving(false);
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                            navigate("".concat(route_names_1.ROUTE_LAYBUY_APPLICATION, "/").concat(steps_1.APP_STEP_KYC, "/").concat((_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.uid));
                        }
                        else {
                        }
                    })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var validateDetails = function () {
        var messageCount = 0;
        if (!laybuyTerm) {
            messageCount++;
            setLaybuyTermError("Lay-buy term is required.");
        }
        if (!laybuyFrequency) {
            messageCount++;
            setLaybuyFrequencyError("Lay-buy payment frequency is required.");
        }
        if (!acceptedLaybuy) {
            messageCount++;
            setAcceptedLaybuyError("Lay-buy payment plan should be accepted before proceeding.");
        }
        return messageCount ? false : true;
    };
    var calculateNumberOfInstallments = function () {
        if (laybuyFrequency && laybuyTerm) {
            var remainingInstallments = parseInt(laybuyTerm) * parseInt(laybuyFrequency);
            return "".concat(remainingInstallments);
        }
        return "N/A";
    };
    var calculateInstallment = function () {
        if (activeLaybuy && (activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.amount) && laybuyFrequency && laybuyTerm) {
            var installmentAmount = ((activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.amount) / (parseInt(laybuyTerm) * parseInt(laybuyFrequency))).toFixed(2);
            return doshx_controls_web_1.Utilities.formatMoney({
                symbol: symbols_1.currencySymbol,
                value: installmentAmount,
                decimalPlaces: 2,
            });
        }
        return "N/A";
    };
    var displayFrequency = function () {
        if (laybuyFrequency && laybuyTerm) {
            return "Installment every ".concat(laybuyFrequency === "1" ? "month" : laybuyFrequency === "2" ? "two weeks" : "week");
        }
        return "Installment frequency";
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement("div", { id: "status", className: "hidden" }),
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement(page_path_1.PagePath, { path: [
                    {
                        page: "/",
                        title: "Home",
                    },
                    {
                        page: "",
                        title: "".concat((activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.is_product) ? "Product" : "", " Lay-buy Application"),
                        active: true,
                    },
                ] }),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat((activeLaybuy === null || activeLaybuy === void 0 ? void 0 : activeLaybuy.is_product) ? "Product" : "", " Lay-buy Application"), textColor: "text-black", bold: true })),
                !airtimeOnly && (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Lay-buy amount:  ".concat(doshx_controls_web_1.Utilities.formatMoney({
                            symbol: symbols_1.currencySymbol,
                            value: laybuyAmount !== null && laybuyAmount !== void 0 ? laybuyAmount : "0",
                            decimalPlaces: 2,
                        })), textColor: "text-black", bold: true }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Number of installments: ".concat(calculateNumberOfInstallments()), textColor: "text-primary", bold: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: " ".concat(displayFrequency(), ": ").concat(calculateInstallment()), textColor: "text-primary", bold: true })),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: laybuyTerms, errorTextColor: "text-red-500", label: "How long do you want the lay-buy for?", size: "small", 
                        // disabled={activeLaybuy?.is_product ? true : false}
                        value: laybuyTerm, errorText: laybuyTermError, onChange: function (v) {
                            setLaybuyTerm(v);
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { options: laybuyFrequencies, errorTextColor: "text-red-500", label: "How frequent will your payments be?", size: "small", 
                        // disabled={activeLaybuy?.is_product ? true : false}
                        value: laybuyFrequency, errorText: laybuyFrequencyError, onChange: function (v) {
                            setLaybuyFrequency(v);
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { errorTextColor: "text-red-500", label: "I accept the Lay-Buy payment plan and wish to proceed with the lay-buy application.", value: acceptedLaybuy, errorText: acceptedLaybuyError, onChange: function (v) {
                            setAcceptedLaybuy(v);
                        } }))),
                react_1.default.createElement("div", { className: "flex justify-center" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Proceed", backgroundColor: "bg-secondary", size: "small", loading: isSaving, enabled: !isSaving, endIcon: pro_solid_svg_icons_1.faArrowRight, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (validateDetails()) {
                                    saveLaybuyDetails();
                                }
                                return [2 /*return*/];
                            });
                        }); } }))))));
};
exports.LaybuyApplicationStart = LaybuyApplicationStart;
